export default __webpack_public_path__ + "static/media/logo-playtomic.cc7ca590.png";